/* ======================================================
   SALES REP AFFILIATE POPUP – FINAL UI IMPROVED
   ====================================================== */

(function () {

  /* ---------------- Inject CSS ---------------- */
  if (!document.getElementById('sr-style')) {
    const style = document.createElement('style');
    style.id = 'sr-style';
    style.innerHTML = `
      #sr-popup {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  font-family: "Work Sans", Helvetica, Arial, sans-serif;
}

.sr-card {
  background: #ffffff;
  width: 360px;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(0,0,0,.25);
  overflow: hidden;
  animation: srFadeIn .35s ease;
  position: relative;
}

/* ---------- TOP SECTION ---------- */
.sr-top {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  background: #e7f3ff;
}

.sr-avatar,
.sr-avatar-text {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  flex-shrink: 0;
}

.sr-avatar {
  object-fit: cover;
  border: 2px solid #e5e7eb;
}

.sr-avatar-text {
  background: #4f46e5;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
}

.sr-name {
  font-size: 20px; /* increased from 18px */
  font-weight: 600;
  color: #111111;
}

/* ---------- BOTTOM SECTION ---------- */
.sr-bottom {
  padding: 14px;
  font-size: 16px; /* increased from 14px */
  color: #444444;
  line-height: 1.6;
  white-space: pre-line;
}

/* ---------- CLOSE BUTTON ---------- */
.sr-close {
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
  font-size: 25px; /* increased from 18px */
  color: #999999;
}

.sr-close:hover {
  color: #000000;
}

/* ---------- ANIMATION ---------- */
@keyframes srFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 700px) {
  #sr-popup {
    left: 50%;
    right: auto;
    bottom: 16px;
    transform: translateX(-50%);
    width: calc(100% - 24px);
    padding: 0 12px;
  }

  .sr-card {
    width: 100%;
    max-width: 420px;
  }
}

@media (max-width: 480px) {
  .sr-avatar,
  .sr-avatar-text {
    width: 56px;
    height: 56px;
    font-size: 16px;
  }

  .sr-name {
    font-size: 17px;
  }

  .sr-bottom {
    font-size: 14px;
  }
}

@media (max-width: 360px) {
  .sr-card {
    border-radius: 12px;
  }

  .sr-name {
    font-size: 16px;
  }
}
    `;
    document.head.appendChild(style);
  }

  /* ---------------- Helpers ---------------- */
  function getInitials(first, last) {
    const f = first ? first.charAt(0) : "";
    const l = last ? last.charAt(0) : "";
    return (f + l || "SR").toUpperCase();
  }

  window.closePopup = function () {
    const el = document.getElementById('sr-popup');
    if (el) el.remove();
  };

  /* ---------------- Render UI ---------------- */
  function renderSalesRep(info) {
    if (document.getElementById('sr-popup')) return;

    const fullName = [info.repname, info.repLastName].filter(Boolean).join(" ");

    const avatarHtml = info.ProfileImagePath
      ? `<img class="sr-avatar" src="${info.ProfileImagePath}" />`
      : `<div class="sr-avatar-text">${getInitials(info.repname, info.repLastName)}</div>`;

    const popup = document.createElement('div');
    popup.id = 'sr-popup';
    popup.innerHTML = `
      <div class="sr-card">
        <span class="sr-close" onclick="closePopup()">×</span>

        <div class="sr-top">
          ${avatarHtml}
          <div class="sr-name">${fullName || "Sales Representative"}</div>
        </div>

        <div class="sr-bottom">
          ${info.bio || ""}
        </div>
      </div>
    `;
    document.body.appendChild(popup);
  }

  /* ---------------- Affiliate Logic ---------------- */
  function loadAffiliate() {
    const url = new URL(window.location.href);
    let repId = url.searchParams.get("ambassador") || url.searchParams.get("AMBASSADOR");
    const linkValidity = url.searchParams.get("v") || url.searchParams.get("V");
console.log("linkValidity",linkValidity);
    if (!repId) {
      document.cookie.split(";").forEach(c => {
        const p = c.split("=");
        if (p[0].trim() === "SR_RepId") repId = p[1];
      });
    }
    if (!repId) return;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'attributes[rep]=' + repId
    });

    if (linkValidity && parseInt(linkValidity) !== 0) {
      const d = new Date();
      d.setTime(d.getTime() + (linkValidity * 86400000));
      document.cookie = "SR_RepId=" + repId + "; expires=" + d.toGMTString();
    }

    const rep_id = repId.replace(/[^\d]/g, '');
    const repname = repId.replace(/\d+/g, '');
        console.log("rep_id",rep_id);
        console.log("repname",repname);

    fetch(`/apps/SalesRep?customerId=${rep_id}&customerName=${repname}&affiliateCodeString=${rep_id}&data=6`)
      .then(r => r.json())
      .then(data => {
        if (!data || !data.rep_info) return;
        console.log("akshay",data.rep_info);
        renderSalesRep(data.rep_info);
      })
      .catch(err => console.error("SalesRep popup error:", err));
  }

  /* ---------------- Init ---------------- */
  document.addEventListener("DOMContentLoaded", loadAffiliate);

})();
